// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import moment from 'moment';
//COMPONENTS
import MUIDataTable from "mui-datatables";
import { Modal } from 'react-bootstrap';
import BlockUi from 'react-block-ui';
//SERVICES AND HELPERS
import * as logEventService from '../../../services/log/logEventService';

const LogEvents = () => {
    const [loading, setLoading] = useState(true);
    const [logs, setLogs] = useState([]);
    const [text, setText] = useState('');

    useEffect(() => {
        getLogs();
    }, []);

    const getLogs = async () => {
        setLoading(true);
        await logEventService.getAllLogEvents().then((res) => {
            setLogs(res);
        }).catch((ex) => {
        }).finally(() => {
            setLoading(false)
        })
    }
    const columns = [
        {
            name: "level",
            label: "Level",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "message",
            label: "Message",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "messageTemplate",
            label: "Message Template",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "exception",
            label: "Exception",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) =>
                    <a href="#" onClick={() => setText(logs[dataIndex].exception)}>{logs[dataIndex].exception ? logs[dataIndex].exception.substring(0, 100) + "..." : ''}</a>
            },
        },
        {
            name: "properties",
            label: "Properties",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "timeStamp",
            label: "Time Stamp",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => <p>{moment(logs[dataIndex].timeStamp).format("MM/DD/YYYY hh:mm a")}</p>
            }
        }
    ];

    const handleModalClose = () => {
        setText('');
    }

    return (
        <BlockUi tag="div" blocking={loading}>
            <Modal centered size="lg" show={text} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Exception</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {text}
                </Modal.Body>
            </Modal>
            <div className="container-fluid">
                <h3>Log Events</h3>
                <button className='btn btn-sm btn-info' onClick={getLogs}>Refresh</button>
                <MUIDataTable
                    data={logs}
                    columns={columns}
                    options={{
                        rowsPerPage: 25,
                        rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                        selectableRows: 'none'
                    }}
                />
            </div>
        </BlockUi>
    )
}

export default LogEvents;